



















import Vue from "vue";
export default Vue.extend({
  props: ["selected", "info_types"],
  setup() {
    return {};
  },
});
